import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { MaintService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetCustomersResolver implements Resolve<any> {

  constructor(@Inject(MaintService) public maintService: MaintService) { }

  resolve() {
    return this.maintService.getCustomers();
  }
}
